import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { PageHeader, SectionCard, Spinner } from '../components/ui';
import { fmtDate, timeAgo } from '../lib/format';

interface AuditItem {
  id: string;
  crmUserId: string | null;
  username: string | null;
  action: string;
  target: string | null;
  meta: unknown;
  ip: string | null;
  ts: number;
}

export function AuditPage() {
  const [items, setItems] = useState<AuditItem[] | null>(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    api.get<{ items: AuditItem[] }>('/api/crm/audit?limit=300').then((r) => setItems(r.items));
  }, []);

  const filtered = items?.filter((it) => {
    if (!search) return true;
    const s = search.toLowerCase();
    return (
      it.action.toLowerCase().includes(s) ||
      (it.username ?? '').toLowerCase().includes(s) ||
      (it.target ?? '').toLowerCase().includes(s)
    );
  });

  return (
    <div>
      <PageHeader
        title="Аудит"
        subtitle="Все действия сотрудников CRM логируются"
        actions={
          <input
            className="input w-64"
            placeholder="Поиск по действию / нику…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        }
      />
      <SectionCard>
        {!items ? (
          <div className="flex items-center gap-2 text-stone-400 text-sm py-4"><Spinner /> Загрузка…</div>
        ) : (filtered?.length ?? 0) === 0 ? (
          <div className="text-sm text-stone-500 py-4">Ничего не найдено</div>
        ) : (
          <div className="overflow-x-auto -mx-3">
            <table className="table-clean">
              <thead>
                <tr>
                  <th>Время</th>
                  <th>Сотрудник</th>
                  <th>Действие</th>
                  <th>Цель</th>
                  <th>Мета</th>
                </tr>
              </thead>
              <tbody>
                {filtered!.map((it) => (
                  <tr key={it.id}>
                    <td className="text-xs text-stone-400 whitespace-nowrap">
                      <div>{timeAgo(it.ts)}</div>
                      <div className="font-mono text-[10px] text-stone-500">{fmtDate(it.ts)}</div>
                    </td>
                    <td className="text-sm">{it.username ?? <span className="text-stone-500">—</span>}</td>
                    <td className="font-mono text-xs text-amber-300">{it.action}</td>
                    <td className="font-mono text-xs text-stone-300">{it.target ?? <span className="text-stone-500">—</span>}</td>
                    <td className="text-[11px] text-stone-400 max-w-[280px] truncate">
                      {it.meta ? <code>{JSON.stringify(it.meta)}</code> : <span className="text-stone-500">—</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </SectionCard>
    </div>
  );
}
